<form [formGroup]="nameChangeRequestForm" (ngSubmit)="submit()">
  <div class="row">
    @if (!!nameChangeRequestForm && !!firstNameInputCtrl && !!lastNameInputCtrl) {
      <fieldset class="column twelve md-six pad-bottom-16">
        <legend
          class="pad-vertical-10"
          dsContent
          [contentPath]="'policy.fullNameInfoText'"
        ></legend>
        <div class="row">
          <div class="column twelve">
            <ds-form-control-container labelText="First name" [control]="firstNameInputCtrl">
              <input
                type="text"
                id="firstNameInput"
                class="fill"
                formControlName="firstNameInputCtrl"
                data-cy="requestChangeFirstNameInput"
              />
              <ds-form-control-message [control]="firstNameInputCtrl"></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
        <div class="row">
          <div class="column twelve">
            <ds-form-control-container labelText="Last name" [control]="lastNameInputCtrl">
              <input
                type="text"
                id="lastNameInput"
                class="fill"
                formControlName="lastNameInputCtrl"
                data-cy="requestChangeLastNameInput"
              />
              <ds-form-control-message [control]="lastNameInputCtrl"></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
      </fieldset>
    }
  </div>

  <!-- User Comments section -->
  <div class="row">
    <fieldset id="comments" class="column twelve">
      <legend
        class="pad-vertical-10"
        dsContent
        [contentPath]="'policy.policyCommentsAdditionalInfoText'"
      ></legend>
      <div class="section-content">
        <ds-form-control-container
          labelText="Details (max 850 characters)"
          [control]="commentInputCtrl"
        >
          <textarea
            maxlength="850"
            id="commentInput"
            class="fill"
            formControlName="commentInputCtrl"
            rows="5"
            data-cy="requestChangeDetailsInput"
          ></textarea>
          <ds-form-control-message [control]="commentInputCtrl"></ds-form-control-message>
        </ds-form-control-container>
        <span class="caption" dsContent [contentPath]="'policy.policyChangeDisclaimer'"></span>
      </div>
    </fieldset>
  </div>

  <!-- Action Buttons -->
  <div class="row">
    <div class="column twelve callToAction">
      <span class="md-float-right">
        <a class="pad-horizontal-20" (click)="cancel()">Cancel</a>
        <button
          ds-button
          type="submit"
          aria-label="Submit"
          class="-outline"
          [disabled]="
            nameChangeRequestForm?.invalid ||
            !nameChangeRequestForm?.dirty ||
            !(roleService?.isAuthorized('reqpolicychangefrm_submit') | async)
          "
          data-cy="primaryButton"
        >
          Submit
        </button>
      </span>
    </div>
  </div>
</form>
